var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenso({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 6.2487C16.9839 6.2487 17.9167 5.31596 17.9167 4.16536C17.9167 3.01477 16.9839 2.08203 15.8333 2.08203C14.6827 2.08203 13.75 3.01477 13.75 4.16536C13.75 5.31596 14.6827 6.2487 15.8333 6.2487Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7082 8.33073V12.7057C17.7082 14.0318 17.1814 15.3036 16.2437 16.2413C15.306 17.1789 14.0343 17.7057 12.7082 17.7057H7.2915C5.96542 17.7057 4.69365 17.1789 3.75597 16.2413C2.81829 15.3036 2.2915 14.0318 2.2915 12.7057V7.28906C2.2915 5.96298 2.81829 4.69121 3.75597 3.75353C4.69365 2.81585 5.96542 2.28906 7.2915 2.28906H11.6665",
    stroke: "#F8F8F8",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05811 12.536L7.89561 10.091C8.00813 9.94042 8.17309 9.8376 8.35782 9.80287C8.54255 9.76815 8.73359 9.80406 8.89311 9.90349L10.6856 11.036C10.8512 11.1415 11.0517 11.1778 11.2438 11.1371C11.4359 11.0964 11.6044 10.982 11.7131 10.8185L13.5581 8.03516",
    stroke: "#F8F8F8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenso);
export default __webpack_public_path__ + "static/media/censo.de90cdda.svg";
export { ForwardRef as ReactComponent };